
export default {

  isDebugEnabled: false,

  //-----LANGUAGE-----
  isLanguageSelectorEnlarged: false,

  //-----SCENE CHANGING-----
  isNewSceneLoading: false,

  //-----SCREEN DIMENSIONS-----
  trueVW: 0,
  trueVH: 0,
  designWidthMobile: 375,
  designHeightMobile: 674,
  designWidthDesktop: 1280,
  designHeightDesktop: 800,
};
